import React from 'react'
import formatNumberCommas from 'Utils/formatNumberCommas'

interface Props {
	prices: {
		price: number
	}[]
}

const MultiplePriceCell: React.FC<Props> = ({ prices }) => {
	return (
		<div className="text-end">
			{prices.map((item, index) => (
				<div key={index}>
					<div className="d-inline-block text-kumopack-grey-900 fw-bolder fs-4">
						{formatNumberCommas(item.price)}
					</div>
					<div className="ms-1 d-inline-block">บาท</div>
				</div>
			))}
		</div>
	)
}

export default MultiplePriceCell
